const videModalDefault = {
  isOpen: false,
  titulo: '',
  urlVideoAjuda: '',
};

const videoModalModel = {
  state: {
    ...videModalDefault,
  },

  reducers: {
    open(state, titulo, urlVideoAjuda) {
      return {...state, isOpen: true, titulo, urlVideoAjuda};
    },
    close(state) {
      return {...state, ...videModalDefault};
    },
  },
};

export default videoModalModel;
